import { SemVer } from './SemVer';
import type { Unparser } from './Unparser';

export class Prologue {
  version: SemVer;

  constructor(version: SemVer) {
    this.version = version;
  }

  toJSON(opts?: { compact?: boolean }): unknown {
    if (opts?.compact) {
      return this.version.toString();
    }
    return {
      version: this.version.toJSON()
    };
  }

  toString(): string {
    return `%CADET-${this.version.toString()}`;
  }

  unparse(u: Unparser): void {
    u.add(this.toString());
  }

  static currentVersion: SemVer = new SemVer(1, 0);

  static currentPrologue: Prologue = new Prologue(this.currentVersion);
}
